import React from 'react';
import { Mail, Phone, MapPin, Clock, MessageCircle } from 'lucide-react';
import { ContactForm } from '../components/ContactForm';
interface KontaktPageProps {
  onNavigate: (page: string) => void;
}
export function KontaktPage({
  onNavigate
}: KontaktPageProps) {
  return <div className="min-h-screen bg-slate-50" data-id="element-796">
      <div className="bg-white py-20 border-b border-slate-200" data-id="element-797">
        <div className="container mx-auto px-4 text-center" data-id="element-798">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-799">
            Kontakt
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-800">
            Wir sind für dich da. Schreib uns oder ruf an. Unser Team freut sich
            auf dich.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-801">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-802">
          <div className="space-y-10" data-id="element-803">
            <div data-id="element-804">
              <h2 className="text-3xl font-bold text-slate-900 mb-8" data-id="element-805">
                So erreichst du uns
              </h2>
              <div className="space-y-8" data-id="element-806">
                <div className="flex items-start gap-6 group" data-id="element-807">
                  <div className="p-4 bg-blue-100 rounded-2xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shadow-sm" data-id="element-808">
                    <Phone className="h-6 w-6" data-id="element-809" />
                  </div>
                  <div data-id="element-810">
                    <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-811">
                      Telefon
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-812">
                      +49 (0) 30 12345678
                    </p>
                    <p className="text-sm text-slate-500 mt-1" data-id="element-813">
                      Mo-Fr, 09:00 - 18:00 Uhr
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6 group" data-id="element-814">
                  <div className="p-4 bg-blue-100 rounded-2xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shadow-sm" data-id="element-815">
                    <Mail className="h-6 w-6" data-id="element-816" />
                  </div>
                  <div data-id="element-817">
                    <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-818">
                      E-Mail
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-819">
                      service@smartprotect24.de
                    </p>
                    <p className="text-sm text-slate-500 mt-1" data-id="element-820">
                      Antwort innerhalb von 24h
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6 group" data-id="element-821">
                  <div className="p-4 bg-blue-100 rounded-2xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shadow-sm" data-id="element-822">
                    <MapPin className="h-6 w-6" data-id="element-823" />
                  </div>
                  <div data-id="element-824">
                    <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-825">
                      Anschrift
                    </h3>
                    <p className="text-slate-600 text-lg leading-relaxed" data-id="element-826">
                      SmartProtect24 GmbH
                      <br data-id="element-827" />
                      Premium Plaza 1<br data-id="element-828" />
                      10115 Berlin
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100" data-id="element-829">
              <h3 className="font-bold text-xl mb-6 flex items-center gap-3 text-slate-900" data-id="element-830">
                <Clock className="h-6 w-6 text-blue-500" data-id="element-831" /> Öffnungszeiten
              </h3>
              <div className="space-y-4 text-slate-600" data-id="element-832">
                <div className="flex justify-between border-b border-slate-100 pb-3" data-id="element-833">
                  <span className="font-medium" data-id="element-834">Montag - Freitag</span>
                  <span className="font-bold text-slate-900" data-id="element-835">
                    09:00 - 18:00
                  </span>
                </div>
                <div className="flex justify-between border-b border-slate-100 pb-3" data-id="element-836">
                  <span className="font-medium" data-id="element-837">Samstag</span>
                  <span className="font-bold text-slate-900" data-id="element-838">
                    10:00 - 14:00
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-839">
                  <span className="font-medium" data-id="element-840">Sonntag</span>
                  <span className="font-bold text-slate-400" data-id="element-841">Geschlossen</span>
                </div>
              </div>
            </div>
          </div>

          <div data-id="element-842">
            <ContactForm data-id="element-843" />
          </div>
        </div>
      </div>
    </div>;
}